import React, {useEffect} from 'react';

import {config} from '../config';
import type {Infinity} from '../services/InfinityClient.service';
import {mediaSessionService} from '../services/MediaSession.service';
import {mediaSignals} from '../signals/Media.signals';

import {InfinityContext} from './infinity.context';

export const InfinityContextProvider: React.FC<
    React.PropsWithChildren<{infinity: Infinity}>
> = ({children, infinity}) => {
    useEffect(() => {
        mediaSessionService.setInfinity(infinity);
        let subscriptions = [
            config.subscribe('bandwidth', bandwidth => {
                infinity.setBandwidth(Number(bandwidth));
            }),
            mediaSignals.onMediaChanged.add(media => {
                if (media?.stream) {
                    infinity.setStream(media.stream);
                }
            }),
        ];
        return () => {
            for (const unsubscribe of subscriptions) {
                unsubscribe();
            }
            subscriptions = [];
            mediaSessionService.setInfinity(undefined);
        };
    }, [infinity]);

    return (
        <InfinityContext.Provider value={infinity}>
            {children}
        </InfinityContext.Provider>
    );
};
